import { render, staticRenderFns } from "./AccountPayments.vue?vue&type=template&id=3e069ff1&"
import script from "./AccountPayments.vue?vue&type=script&lang=js&"
export * from "./AccountPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports